import { BigNumber, ethers } from "ethers";
import { useWeb3Ts } from "../context/Web3TsContext";
import { NumberFormater } from "../utils/formater/NumberFormater";
import { myToast } from "../utils/toast";
import { useAccount } from "./useAccount";
import { useBalance } from "./useBalance";
import { useContract } from "./useContract";
import { useRefAddress } from "./useRefAddress";
export type BuyMethod = "usdt" | "bnb";
export const useBuy = () => {
 const { balance } = useBalance();
 const { refAddr } = useRefAddress();
 const { account } = useAccount();
 const { contractBuy: contract, contractUsdt } = useContract();
 const web3TsConfig = useWeb3Ts();
 const buy = async ({
  value,
  method,
 }: {
  value: number;
  method?: BuyMethod;
 }) => {
  try {
   if (web3TsConfig.config.buyContract.disableBuy === true) {
    throw new Error("Buy is disabled");
   }
   method = method ?? "bnb";
   if (!value) {
    throw new Error("Input value");
   }
   let _minBuy = 0;
   let _maxBuy: number | undefined = undefined;
   if (method === "bnb") {
    _minBuy = web3TsConfig.buyMetadata.minBuy ?? 0;
    _maxBuy = web3TsConfig.buyMetadata.maxBuy;
   } else if (method === "usdt") {
    _minBuy = web3TsConfig.buyMetadata.minBuyUSDT ?? 0;
    _maxBuy = web3TsConfig.buyMetadata.maxBuyUSDT;
   }
   if (_minBuy && value < _minBuy) {
    throw new Error(`Buy as low as ${NumberFormater.format(_minBuy)}`);
   }
   if (_maxBuy && value > _maxBuy) {
    throw new Error(`Buy as than as ${NumberFormater.format(_maxBuy)}`);
   }
   if ((method === "bnb" ? value : 0) + web3TsConfig.gasFee > balance) {
    throw new Error(
     `Your balance is insufficient, gas estimate is ${web3TsConfig.gasFee}`
    );
   }

   if (!(contract && contractUsdt)) return false;
   // eslint-disable-next-line @typescript-eslint/ban-types
   let toastRef: Function | undefined;
   const etherValue = ethers.utils.parseEther(value + "").toBigInt();
   if (method === "usdt") {
    const resp = (await contractUsdt.allowance(
     account,
     web3TsConfig.config.buyContract.contractAddress
    )) as BigNumber;
    const allowableValue = +ethers.utils.formatUnits(resp);
    if (allowableValue < value) {
     toastRef = myToast.toastWait({ message: `Ready allowance` });
     const block = await contractUsdt.approve(
      web3TsConfig.config.buyContract.contractAddress,
      etherValue
     );
     toastRef();
     toastRef = myToast.waitTransaction();
     await block.wait();
    }

    const block = await contract[
     web3TsConfig.config.buyContract.buyUSDTMethod!
    ](etherValue, refAddr ?? account);
    toastRef?.();
    toastRef = myToast.toastWait({ message: "Signing Buy started" });
    await block.wait();
   } else {
    const block = await contract[web3TsConfig.config.buyContract.buyMethod](
     refAddr ?? account,
     {
      value: etherValue,
     }
    );
    toastRef?.();
    toastRef = myToast.toastWait({ message: "Signing Buy started" });
    await block.wait();
   }
   toastRef?.();
   toastRef = myToast.toastWait({ message: "Transaction successfully" });
  } catch (_error) {
   const error = _error as { reason?: string; message?: string };
   if (error.reason || error.message) {
    myToast.toast(error.reason || error.message, { type: "error" });
   }
   throw error;
  }
  return true;
 };
 return {
  buy,
 };
};
